"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ArrowDownOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var ArrowDownOutlineSVG = function ArrowDownOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M24.69,17.19h0a1,1,0,0,0-1.48,0L17,23.5V6a1,1,0,1,0-2,0V23.5L8.79,17.19a1,1,0,0,0-1.48,0h0a1.07,1.07,0,0,0,0,1.5l7.89,8A1.09,1.09,0,0,0,16,27a1.13,1.13,0,0,0,.8-.31l7.89-8A1.07,1.07,0,0,0,24.69,17.19Z"
  }));
};
exports.ArrowDownOutlineSVG = ArrowDownOutlineSVG;
ArrowDownOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ArrowDownOutlineSVG);
exports.default = _default;